module.exports = "<header class=\"kl-header {class}\" r-style={ {height: height} }>\n    {#inc this.$body}\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLLayout/KLHeader/index.html
// module id = 563
// module chunks = 0